<template>
    <div
            class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div v-if="send_store" class="card-body">
                        <form action="" @submit="requestCalculation">
                            <div class="flex">
                                <div>
                                    <label>Склад отправитель</label>
                                    <select v-model="send_store" name="send_store" class="form-control">
                                        <option
                                                v-for="(store, index) in send_store_list" :key="index"
                                                :value="store.id">{{ store.name }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <label>Склад получатель</label>
                                    <select v-model="receive_store" name="receive_store" class="form-control">
                                        <option
                                                v-for="(store, index) in receive_store_list" :key="index"
                                                :value="store.id">{{ store.name }}
                                        </option>
                                    </select>
                                </div>
                                <div style="position: relative;min-width: 200px;">
                                    <button style="position: absolute;bottom: 0" class="btn btn-info" type="submit">
                                        Создать автосписок
                                    </button>
                                    <label for="check_1">
                                        <input type="checkbox" class="from-control" v-model="default_formula" name=""
                                               id="check_1">
                                        Использовать 60/17
                                    </label>
                                    <div class="clearfix"/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <pulse-loader :loading="loading" :color="color" style="text-align: center"/>
        </div>

        <div v-if="request" class="row">

            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <H5>Перемещение <strong>{{send_store_name}}</strong> в <strong>{{receive_store_name}}</strong>
                            на сумму: <strong>{{calculated_total_sum_value}}</strong></H5>
                        <div class="flex blocks-2">
                            <div>
                                <div>
                                    <label for="check_2">
                                        <input type="checkbox" v-model="noCloseVisible" name="" id="check_2">
                                        Показать препараты, которые не закрываются
                                    </label>
                                </div>
                                <div>
                                    <label for="check_3">
                                        <input type="checkbox" v-model="storeDetailsVisible" name="" id="check_3">
                                        Показать детали
                                    </label>
                                </div>
                                <div>
                                    <label for="check_4">
                                        <input type="checkbox" v-model="showReserve" name="" id="check_4">
                                        Показать брони
                                    </label>
                                </div>
                                <div>
                                    <label for="check_5">
                                        <input type="checkbox" v-model="hideNoReserve" name="" id="check_5">
                                        Отправлять только бронь
                                    </label>
                                </div>
                            </div>
                            <div>
                                <button @click="printTable" class="btn btn-success">Печать</button>
                            </div>
                        </div>
                        <div id="printTable">
                            <table class="table table-hover table-bordered">
                                <thead>
                                <th class="wd-40"/>
                                <th class="wd-40"></th>
                                <th>Препарат</th>
                                <th v-show="hideNoReserve" class="wd-200">Только бронь</th>
                                <th v-show="!hideNoReserve" class="wd-200">Всего</th>
                                <th class="wd-100" v-show="showReserve">Срочная бронь</th>
                                <th class="wd-100" v-show="showReserve">Обычная бронь</th>
                                <th class="wd-100" v-show="showReserve">Запас</th>
                                <th class="wd-100" v-show="storeDetailsVisible">Не закрываем бронь</th>
                                <th class="wd-100" v-show="storeDetailsVisible">Не закрываем запас</th>
                                <th class="wd-100" v-show="storeDetailsVisible">Не закр. запрос запаса на отправителе
                                </th>
                                <th v-show="!hideNoReserve" class="wd-100">Сумма</th>
                                <th v-show="hideNoReserve" class="wd-100">Сумма брони</th>
                                <th class="wd-200">Морион</th>
                                </thead>
                                <tbody>
                                <tr v-for="(prep, index) in orderedPrepNames(request.prep_names)" :key="index">
                                    <td class="row_num">{{1+index}}</td>
                                    <td><span v-if="prep.cool" class="icon icon-snowflake"/></td>
                                    <td>{{ prep.name }}
                                        <span class="pack_details" v-if="request.pack_details[prep.id]"><br>{{request.pack_details[prep.id]}}</span>
                                        <span class="store_details text-muted" v-if="request.store_details[prep.id]"><br>{{request.store_details[prep.id]}}</span>
                                    </td>
                                    <td v-show="hideNoReserve">{{request.reserve_for_close[prep.id]}}</td>
                                    <td v-show="!hideNoReserve">{{printAll(prep.id)}}</td>
                                    <td v-show="showReserve">{{request.reserve_requests.urgent[prep.id] ? request.reserve_requests.urgent[prep.id] : ''}}</td>
                                    <td v-show="showReserve">{{request.reserve_requests.regular[prep.id] ? request.reserve_requests.regular[prep.id] : ''}}</td>
                                    <td v-show="showReserve">{{request.store_requests[prep.id] ? request.store_requests[prep.id] : ''}}</td>
                                    <td v-show="storeDetailsVisible">{{printNoCloseFigures(prep.id,'reserve')}}</td>
                                    <td v-show="storeDetailsVisible">{{printNoCloseFigures(prep.id,'storage')}}</td>
                                    <td v-show="storeDetailsVisible"></td>
                                    <td v-show="!hideNoReserve"></td>
                                    <td v-show="hideNoReserve"></td>
                                    <td>{{prep.id}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <!--              <button @click="invoice_div = !invoice_div" class="btn btn-success">Создать накладную</button>-->
                        </div>

                        <div v-show="invoice_div">
                            <div class="p-20 p-b-10">
                                <p>Перемещение <strong>{{send_store_name}}</strong> на
                                    <strong>{{receive_store_name}}</strong></p>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <VueCtkDateTimePicker v-model="invoice_date" format="DD.MM.YYYY HH:mm"
                                                          minute-interval="10"
                                                          buttonNowTranslation="Сегодня" label="Дата и время доставки"/>
                                </div>
                                <div class="col-md-4">
                                    <select v-model="invoice_status" class="form-control">
                                        <option value="1">предварительная ведомость</option>
                                        <option value="2">в дороге</option>
                                        <option value="0">фактическое перемещение</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <div class="form-group p-t-10">
                                    <label>Комментарий</label>
                                    <input v-model="invoice_comment" placeholder="" class="form-control">
                                </div>
                                <vue-ladda @click="createInvoice" button-class="btn btn-info" data-style="zoom-in"
                                           :loading="submit_form_loading">Создать
                                </vue-ladda>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import api from '@/api'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
    import VueLadda from 'vue-ladda/src/vue-ladda.vue'
    import VueHtmlToPaper from 'vue-html-to-paper';

    Vue.use(VueHtmlToPaper, {
        name: '_blank',
        specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=yes'
        ],
        styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css',
            '/assets/css/print.css'
        ]
    });

    export default {

        components: {
            PulseLoader,
            VueCtkDateTimePicker,
            VueLadda
        },
        data() {
            return {
                calculated_total_sum_value: 0,
                calculated_reserve_sum_value: 0,
                hideNoReserve: false,
                showReserve: true,
                requestDetailsVisible: false,
                submit_form_loading: false,
                invoice_date: null,
                invoice_to: null,
                invoice_from: null,
                invoice_comment: null,
                invoice_status: 1,
                receive_store_name: null,
                send_store_name: null,
                color: '#5BBFDE',
                loading: null,
                request: null,
                send_store: null,
                receive_store: null,
                send_store_list: null,
                receive_store_list_data: null,
                default_formula: false,
                noCloseVisible: false,
                storeDetailsVisible: false,
                invoice_div: false,
                showRow: false,
                row_i: 0,
            }
        },
        computed: {
            receive_store_list() {
                if (this.receive_store_list_data) {
                    // this.receive_store = this.receive_store_list_data[this.send_store][0].id
                    let keys = Object.keys(this.receive_store_list_data[this.send_store])
                    this.receive_store = this.receive_store_list_data[this.send_store][keys[0]].id
                    return this.receive_store_list_data[this.send_store]
                }
            }
        },

        mounted() {
            this.getStores()
            let someDate = new Date()
            someDate.setDate(someDate.getDate() + 2)

            let dd = someDate.getDate()
            // let mm = someDate.getMonth() + 1
            let mm = ("0" + (someDate.getMonth() + 1)).slice(-2)
            let y = someDate.getFullYear()

            let coeff = 1000 * 60 * 10
            let date = new Date()  //or use any other date
            let rounded = new Date(Math.round(date.getTime() / coeff) * coeff)

            this.invoice_date = dd + '.' + mm + '.' + y + ' ' + rounded.getHours() + ':' + rounded.getMinutes()

        },
        watch: {
            showReserve(val){ if(val) this.hideNoReserve = false },
            storeDetailsVisible(val){ if(val) this.hideNoReserve = false },
            hideNoReserve(val){
              if (val){
                  this.showReserve = false
                  this.storeDetailsVisible = false
                  this.noCloseVisible = false

                  this.request.prep_names = [...this.allRows.filter((r) => {
                      return r.reserve_only;
                  })];
              }else{
                  this.request.prep_names = [...this.allRows.filter((r) => {
                      return r.close;
                  })];
              }
            },
            noCloseVisible(val) {
                // this.row_i = 0;
                if (val) {
                    this.request.prep_names = [...this.allRows];
                    this.hideNoReserve = false;

                    this.showRow = true;
                } else {
                    this.request.prep_names = [...this.allRows.filter((r) => {
                        return r.close;
                    })];
                    this.showRow = false;
                }

            },
        },
        methods: {
            printNoCloseFigures(id, type) {

                let diff = 0;
                let total_reserve = +this.request.reserve_requests.urgent[id] + +this.request.reserve_requests.regular[id];

                diff = this.request.actual_store[id] - total_reserve;

                if (type == 'reserve') {
                    if (this.request.actual_store[id] < total_reserve) return total_reserve - this.request.actual_store[id];
                }

                if (type == 'storage' && this.request.store_requests[id]) {
                    if (diff <= 0) return this.request.store_requests[id]
                    return diff >= this.request.store_requests[id] ? '' : diff;
                }


            },
            printAll: function (id) {

                // return this.request.reserve_for_close[id];

                if (!this.request.total_num_for_send[id]) return;
                let text = '';
                if (this.request.total_num_for_send[id]){
                    text += this.request.total_num_for_send[id];
                }
                if (this.request.reserve_for_close[id]){
                    text += ' (бронь - ' + this.request.reserve_for_close[id] + ')';
                }

                return text;

                return this.request.reserve_for_close[id] + ' (бронь - '+ this.request.reserve_for_close[id] + ')';

                if (!this.request.reserve_requests.urgent[id]) this.request.reserve_requests.urgent[id] = 0;
                if (!this.request.reserve_requests.regular[id]) this.request.reserve_requests.regular[id] = 0;
                if (!this.request.store_requests[id]) this.request.store_requests[id] = 0;

                let total_reserve = +this.request.reserve_requests.urgent[id] + +this.request.reserve_requests.regular[id];

                if (this.request.actual_store[id] && this.request.actual_store[id] > 0) {
                    // this.request.prep_names[id].is_closed = true;
                    if (total_reserve) {
                        if (this.request.actual_store[id] >= (total_reserve + this.request.store_requests[id])) {
                            return (total_reserve + this.request.store_requests[id]) + ' (бронь - ' + total_reserve + ')';
                        }

                        if (this.request.actual_store[id] >= total_reserve) {
                            let remain = this.request.actual_store[id] - total_reserve;
                            if (remain == 0) return total_reserve;

                            return (total_reserve + this.request.store_requests[id] - this.request.actual_store[id]) + ' (бронь - ' + total_reserve + ')';
                        }

                        if (this.request.actual_store[id] < total_reserve) {
                            return this.request.actual_store[id];
                        }
                    } else if (this.request.store_requests[id]) {

                        if (this.request.actual_store[id] >= this.request.store_requests[id]) return this.request.store_requests[id];
                        return this.request.actual_store[id];

                    }
                } else {
                    // this.request.prep_names[id].is_closed = false;
                }
            },
            printReservePriceOnly(prepId) {
                let qnty = this.getReserveTotal(prepId, false)
                let sum = qnty * this.request.prices[prepId]
                // sum = +(Math.round(sum + "e+2") + "e-2");
                return sum;
            },
            calculate_total_sum(reserve = false) {
                if (reserve) {
                    this.calculated_total_sum_value = (this.calculated_reserve_sum_value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
                } else {
                    this.calculated_total_sum_value = (this.request.total_prices.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');  // 12 345.67;
                }
            },
            getClassForHide(prepId) {
                if (!this.getReserveTotal(prepId, false)) return 'zero_reserve';
                return
            },
            hideZeroReserve(check = true) {
                let table = document.getElementsByClassName('table');
                let tbodies = document.querySelectorAll('.table tbody');
                // let number = 1
                for (let tbody of tbodies) {
                    if (typeof tbody.querySelectorAll('.zero_reserve')[0] !== "undefined") {
                        if (check) {
                            tbody.querySelectorAll('.zero_reserve')[0].classList.add('hide')
                        } else {
                            tbody.querySelectorAll('.zero_reserve')[0].classList.remove('hide')
                        }
                    }
                }
            },
            printTable() {
                this.$htmlToPaper('printTable');
            },
            getReserveTotal(prepId, text = true) {
                let sum = 0;
                if (this.printFigure(this.request.total_figures[prepId].urgent, 'close')) sum += this.printFigure(this.request.total_figures[prepId].urgent, 'close') * 1
                if (this.printFigure(this.request.total_figures[prepId].regular, 'close')) sum += this.printFigure(this.request.total_figures[prepId].regular, 'close') * 1
                if (!text) return sum;
                return sum !== 0 ? '( бронь - ' + sum + ' )' : '';
            },
            createInvoice: async function (e) {
                this.submit_form_loading = true
                e.preventDefault()
                try {
                    const {data} = await api.store('/createAutolistInvoice', {
                        invoice_date: this.invoice_date,
                        invoice_to: this.invoice_to,
                        invoice_from: this.invoice_from,
                        invoice_comment: this.invoice_comment,
                        invoice_status: this.invoice_status
                    })

                    if (data.success) {
                        this.request = null
                        toastr['success']('Сохранено', 'Успешно')
                    } else {
                        toastr['danger'](data.message, 'Ошибка')
                    }

                } catch (e) {
                    toastr['danger']('Сервер не ответил!', 'Ошибка')
                }
                this.submit_form_loading = false
            },
            calculateSumm: function (prep, prepId, field) {
                let summ = 0
                let set = ''
                if (prep.urgent && prep.urgent[field]) summ += prep.urgent[field]
                if (prep.regular && prep.regular[field]) summ += prep.regular[field]
                if (prep.store && prep.store[field]) summ += prep.store[field]
                if (this.request.prep_komplekt[prepId]) set = +(Math.round((summ / this.request.prep_komplekt[prepId]) + "e+2") + "e-2");
                summ = +(Math.round(summ + "e+2") + "e-2");
                return {
                    'summ': summ,
                    'set': set ? (' завод. упак. <p class="small_blue">(' + set + ' комплекта в прог.)</p>') : ''
                }
            },
            isPrepNoClose: function (prep) {
                if (prep.urgent && prep.urgent.close) return false
                if (prep.regular && prep.regular.close) return false
                if (prep.store && prep.store.close) return false
                return true
            },
            printFigure: function (data, field) {
                if (!data) return ''
                return data[field] ? Math.round(data[field]) : ''
            },
            orderedPrepNames: function (preps, request = false) {
                let sorted = _.orderBy(preps, 'name')
                if (request) {
                    sorted = sorted.filter(x => request[x.id])
                }
                return sorted
            },
            async getStores() {
                const {data} = await api.index('/getStores')
                this.send_store_list = data.stores.send
                this.send_store = this.send_store_list[Object.keys(this.send_store_list)[0]].id
                this.receive_store_list_data = data.stores.receive
            },

            requestCalculation: async function (e) {
                this.loading = true
                this.request = null

                this.invoice_from = this.send_store
                this.invoice_to = this.receive_store

                this.send_store_name = this.send_store_list[this.send_store].name
                this.receive_store_name = this.receive_store_list_data[this.send_store][this.receive_store].name
                e.preventDefault()
                try {
                    const {data} = await api.store('/createAutolist', {
                        send_store: this.send_store,
                        receive_store: this.receive_store,
                        default_formula: this.default_formula
                    })


                    this.allRows = data.prep_names;

                    this.request = {
                        prep_names: [...this.allRows.filter((r) => {
                            return r.close;
                        })],
                        reserve_requests: data.reserve_requests,
                        store_requests: data.store_requests,
                        actual_store: data.actual_store,
                        reserve_for_close: data.reserve_for_close,
                        total_num_for_send: data.total_num_for_send,
                        store_details: data.store_details,
                        pack_details: data.pack_details
                    }


                    // Object.keys(data.prices).forEach((key) => {
                    //     let qnty = this.getReserveTotal(key, false)
                    //     if (qnty){
                    //         this.calculated_reserve_sum_value += (data.prices[key] * qnty);
                    //     }
                    // });


                    // this.calculate_total_sum();
                    this.loading = false
                } catch (e) {
                    console.log(e)
                }
            }
        }
    }

</script>

<style scoped>
    .icon {
        display: block;
        width: 17px;
        height: 19px;
        background: #5BBFDE;
        margin: 0 auto;
    }

    .icon-snowflake {
        mask: url(/assets/svg/snowflake-solid.svg);
    }

    .clearfix {
        clear: both;
    }

    .p-20 {
        padding: 20px;
    }

    .p-t-10 {
        padding-top: 10px;
    }

    .p-b-10 {
        padding-bottom: 10px;
    }

    .flex {
        display: flex;
        /*justify-content: space-around;*/
    }

    .flex.blocks-2 div {
        margin: 0;
        margin-right: 15px;
    }

    .blocks-2 {
        justify-content: space-between;
    }

    .flex div {
        margin-left: 20px;
    }

    .wd-40 {
        width: 40px;
    }

    .wd-100 {
        white-space: normal;
        width: 110px;
    }

    .wd-200 {
        width: 115px;
    }

    .btn.ladda-button {
        padding: 2px 17px;
    }

    .btn-info.ladda-button {
        background-color: #5BBFDE;
    }

    span.pack_details {
        font-size: 12px;
        color: #3bb3d8;
    }

    span.store_details {
        font-size: 12px;
    }

    p.small_blue {
        /*display: block;*/
        font-size: 12px;
        color: #3bb3d8;
        margin: 0;
    }

    table td {
        padding: 2px;
    }

    .zero_reserve.hide {
        display: none;
    }
</style>

<style>
    p.small_blue {
        /*display: block;*/
        font-size: 12px;
        color: #3bb3d8;
        margin: 0;
    }
</style>
